import React from 'react';

import './styles.css';

import { 
    Dialog, 
    DialogTitle, 
    DialogContent, 
    DialogActions, 
    InputAdornment, 
    Tooltip, 
    Divider, 
    Tabs, 
    Tab, 
    Alert, 
    AlertTitle, 
    Typography, 
    Box, 
    Button, 
    Grid, 
    TextField,
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    Autocomplete
} from "@mui/material"

import LoadingButton from '@mui/lab/LoadingButton';

import Loading from '../../Loading';
import Modal from "../../Templates/360dialog/Modal"

import api from '../../../api';
import { getSession } from "../../../auth";

import useNotification from '../../Notification';
import useValidationError from '../../ErrorValidation';
import ParameterFiller from './ParameterFiller';

import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import { alphabeticalSort } from '../../../utils/alphabeticalSort';

const TEMPLATE_APPROVAL_POLL_INTERVAL_MS = 5000
const TEMPLATE_APPROVAL_TIMEOUT_MS = 5 * 60 * 1000
const TEMPLATE_APPROVAL_WAITING_MESSAGE = "Aguardando aprovação da Meta. Isso pode levar alguns minutos."
const TEMPLATE_APPROVAL_TIMEOUT_MESSAGE = "A aprovação pela Meta está demorando mais do que o esperado e pode levar até 24h. Você pode voltar mais tarde, assim que o template for aprovado."

class Templates extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTemplate  : null,
            showParameters    : false,
            parameters        : [],
            queues            : [],
            queue             : null,
            originNumber      : null,
            loading           : false,
            mediaParameters   : {},
            allParamsFilled   : true,
            filteredTemplates : [],
            numberTemplates   : [],
            numberLoading     : false,
            templateTab       : 0,
            newTemplateDialog : false,
            templateLoading   : false,
            templateLoadingMessage: TEMPLATE_APPROVAL_WAITING_MESSAGE,
            templateLoadingClosable: false
        }
    }

    onChangeQueues = (event) => {
        this.setState({ queue: event.target.value });
    }

    onChangeOriginNumbers = (value, callback) => {
        if (! value)
            return
        if (getSession().profile.enterprise.abstraction_layer) {
            this.setState({ numberLoading: true })
            const enterpriseId = getSession().profile.enterprise.id
            const number = value.replace(/\D/g, '');
            const setTemplates = (attempt = 0) => {
                api.get(`api/enterprises/${enterpriseId}/templates/${number}/`)
                .then((res) => {
                    if (res.status === 200) {
                        if (res.data === 'caching...') {
                            if (attempt < 2) {
                                setTimeout(() => setTemplates(attempt + 1), 2000)
                            } else {
                                this.setState({ numberLoading: false })
                                useNotification(
                                    'Atenção!',
                                    'Não foi possível encontrar os templates do número, tente novamente em alguns instantes.',
                                    'warning'
                                );
                            }
                        } else {
                            const templates = res.data.waba_templates.filter((t) => t.status.toLowerCase() === 'approved')
                            this.setState({
                                numberLoading     : false,
                                numberTemplates   : templates,
                                originNumber      : value,
                                filteredTemplates : templates
                            })   
                            if (callback) callback();
                        }
                        return
                    }
                    throw err
                })
                .catch((err) => { this.setState({ numberLoading: false }) })
            }
            setTemplates()
        } else { this.setState({ originNumber: value }); }
    }

    fillParameters = () => {
        if (! this.state.selectedTemplate)
            return
        
        const requiredParameters = []
        if (this.state.selectedTemplate.components.length == 1 && this.state.selectedTemplate.components[0].type == 'BODY') {
            let amount = this.matchRegLen(this.state.selectedTemplate.components[0].text)
            if (amount)
                requiredParameters.push(
                    {
                        type: 'BODY',
                        amount: amount
                    }
                )
        }
        else {
            this.state.selectedTemplate.components.map(component => {
                let amount = 0
                if (component.type == 'HEADER') {
                    amount = 1
                    if (component.format == 'TEXT')
                        amount = this.matchRegLen(component.text)
                    if (amount)
                        requiredParameters.push({
                            type: component.type,
                            format: component.format,
                            amount: amount
                        })
                }
                else if (component.type == 'BODY') {
                    amount = this.matchRegLen(component.text)
                    if (amount)
                        requiredParameters.push(
                            {
                                type: 'BODY',
                                amount: amount
                            }
                        )
                }

                else if (component.type == 'BUTTONS') {
                    amount = 0
                    component.buttons.map(button => {
                        if (button.type === 'URL')
                            amount += this.matchRegLen(button.url)
                    })
                    if (amount)
                        requiredParameters.push(
                            {
                                type: 'BUTTONS',
                                amount: amount
                            }
                        )
                }

            })
        }
        if (requiredParameters.length > 0) {
            this.setState({
                showParameters: true,
                parameters: requiredParameters
            });
        }
    }

    submit = () => {
        if ("headerURL" in this.state.mediaParameters) {
            this.sendMediaNotification()
            return
        }
        this.sendNotification()
    }

    matchRegLen = value => {
        if (!value)
            return
        const matcher = value.match(/{{\d+}}/g)
        if (matcher)
            return matcher.length
        return 0
    }

    getCountTemplateParameters = () => {
        return (this.state.selectedTemplate.components[0].text.match(/{{/g) || []).length;
    }
    
    postNotification = (body) => {
        this.setState({ loading: true });
        api.post(`api/whatsapp/notification/`, body, { timeout: 0 })
            .then(async (res) => {
                await this.setState({ loading: false });
                if (res.status === 201) {
                    await this.props.handleClose();
                    useNotification(
                        'Sucesso!',
                        'Notificação enviada.',
                        'success'
                    );
                    await this.props.handlePostSuccess();

                    return;
                }
                throw res;
            })
            .catch((err) => {
                useValidationError(err.status, err.data?.message);
                console.error(err);
            });
    }

    sendMediaNotification = async () => {
        const user = getSession()
        // Must validate parameters.

        if (this.props.setup){
            const {numberTemplates, filteredTemplates, queues , ...data} = this.state
            const result = await this.props.setup(data)
            if (result !== false) {
                this.props.handleClose()
            }
            return
        }

        this.setState({ loading: true });

        let formdata = new FormData()
        const parameters = this.state.mediaParameters

        const clients = this.props.clients;
        const selectionIds = this.props.selectionIds;

        let parsed = {}
        let recipients = [];
        if (this.props.selectedNumberModel) {
            recipients = this.props.selectedNumberModel
        }
        else {
            clients.map(each => { parsed[each.id] = each })
            selectionIds.forEach((id) => {
                if (id in parsed && 'telephone' in parsed[id])
                    recipients.push(parsed[id].telephone);
            });
        }

        if (!('headerfile' in parameters) && 'headerURL' in parameters) {
            // add json format
            formdata = {
                'headerURL' : parameters.headerURL,
                'body'      : parameters?.body ? Object.values(parameters.body) : '',
                'buttons'   : parameters.buttons,
                'from'      : this.state.originNumber,
                'to'        : recipients,
                'queue_name': this.state.queue.split('_').pop(),
                'template'  : this.state.selectedTemplate.name,
                'agent'     : user.profile.agent.user.split('_').pop()
            }
        } else {
            if ('headerfile' in parameters)
                formdata.append('headerfile', parameters.headerfile)
            if ('headerbody' in parameters)
                formdata.append('headerbody', parameters.headerbody)
            if ('body' in parameters)
                Object.values(parameters.body).map(p => formdata.append('body', p))
            if ('buttons' in parameters)
                formdata.append('buttons', parameters.buttons)

            formdata.append('from', this.state.originNumber)
            formdata.append('to', recipients)
            formdata.append('queue_name', this.state.queue.split('_').pop())
            formdata.append('template', this.state.selectedTemplate.name)
            formdata.append('agent', user.profile.agent.user.split('_').pop())
        }

        localStorage.setItem("last_template_queue", this.state.queue)
        localStorage.setItem("last_template_number", this.state.originNumber)

        api.post(`api/whatsapp/medianotification/`, formdata, {timeout:30000})
            .then(async (res) => {
                await this.setState({ loading: false });
                if (res.status === 201) {
                    await this.props.handleClose();
                    useNotification(
                        'Sucesso!',
                        'Notificação enviada.',
                        'success'
                    );
                    await this.props.handlePostSuccess();
                    this.setState({
                        showParameters: false,
                        mediaParameters: {},
                        parameters: []
                    })
                    return;
                }
                throw res;
            })
            .catch((err) => {
                let message = 'Ocorreu uma falha no sistema'
                if (err.status === 400 && err.data.file)
                    message = 'Formato de arquivo não aceito.'
                else if (err.status === 400 && err.data.format)
                    message = 'Imcompatibilidade na contagem de parâmetros.'
                useNotification(
                    'Falha',
                    message,
                    'danger'
                );
                console.error(err);
            });
    }

    handleChangeImage = async () => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = 'image/*'
        
        input.onchange = async (e) => {
            const file = e.target.files[0]
            if (!file) return
            
            this.setState({ loading: true })
            const formData = new FormData()
            formData.append('file', file)
            
            try {
                const res = await api.post(`api/whatsapp/uploadmedia/`, formData, { timeout: 15000 })
                
                if (res.status !== 200) {
                    useNotification(
                        'Erro ao fazer upload',
                        'Não foi possível fazer upload da imagem. Tente novamente.',
                        'danger'
                    )
                    this.setState({ loading: false })
                    return
                }
                
                this.setState(prevState => ({
                    ...prevState,
                    mediaParameters: {
                        ...prevState.mediaParameters,
                        headerURL: res.data,
                        headerfile: undefined
                    },
                    loading: false
                }))
                
                useNotification(
                    'Sucesso',
                    'Imagem atualizada com sucesso!',
                    'success'
                )
            } catch (error) {
                if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
                    useNotification(
                        'Tempo de resposta excedido',
                        'O tempo limite para upload da imagem foi excedido. Verifique sua conexão e tente novamente.',
                        'danger'
                    )
                } else {
                    useNotification(
                        'Erro ao fazer upload',
                        'Não foi possível fazer upload da imagem. Tente novamente.',
                        'danger'
                    )
                }
                this.setState({ loading: false })
            }
        }
        
        input.click()
    }

    sendNotification = async () => {
        const clients = this.props.clients;
        const selectionIds = this.props.selectionIds;
        const user = getSession()

        let parsed = {}
        let recipients = [];
        if (this.props.selectedNumberModel) {
            recipients = this.props.selectedNumberModel
        }
        else {
            clients.map(each => { parsed[each.id] = each })
            selectionIds.forEach((id) => {
                if (id in parsed && 'telephone' in parsed[id])
                    recipients.push(parsed[id].telephone);
            });
        }

        localStorage.setItem("last_template_queue", this.state.queue)
        localStorage.setItem("last_template_number", this.state.originNumber)

        let parameters = []
        if ("body" in this.state.mediaParameters)
            parameters = Object.values(this.state.mediaParameters["body"])

        const body = {
            'from': this.state.originNumber,
            'to': recipients,
            'queue_name': this.state.queue.split('_').pop(),
            'template': this.state.selectedTemplate.name,
            'parameters': parameters,
            'agent': user.profile.agent.user.split('_').pop()
        };

        if (this.props.setup) {
            const {numberTemplates, filteredTemplates, queues, ...data} = this.state
            const result = await this.props.setup(data)
            if (result !== false) {
                this.props.handleClose()
            }
            return
        }

        this.postNotification(body);
    }

    handleInputChange = (e, i) => {
        const { value } = e.target;
        const parameters = this.state.parameters;

        parameters[i] = {};
        parameters[i]['value'] = value;

        this.setState({
            parameters: parameters
        });
    }

    allParametersFilled = (value) => {
        this.setState({ allParamsFilled: value })
    }

    getQueues = () => {
        let queues = this.props.queues;
        let newQueues = [];
        if (Object.keys(queues) && Object.keys(queues).length) {
            Object.keys(queues).map(key => {
                newQueues.push(key);
            });
        }
        this.state.queues = newQueues.sort((x,y) => alphabeticalSort(x,y,''));
    }

    componentWillMount = () => {
        this.getQueues();

        if (window?.activity?.whatsapp){
            const data = window?.activity?.whatsapp
            this.onChangeOriginNumbers(data.originNumber, () => {this.handleStoredTemplate(data.selectedTemplate.name)})
            this.setState({
                filteredTemplates : this.props.templates,
                ...data,
                showParameters: false
            })
            
            return 
        } 

        const storedQueue  = localStorage.getItem("last_template_queue")
        const storedNumber = localStorage.getItem("last_template_number")

        this.setState({
            filteredTemplates : this.props.templates,
            queue             : storedQueue,
            originNumber      : storedNumber
        })
        
        this.onChangeOriginNumbers(storedNumber)

        if (this.props.reactivationSenders && this.props.reactivationSenders.length !== 0) {
            // TODO: handle cases where senders might be different
            this.onChangeOriginNumbers(this.props.reactivationSenders[0])
        }
    }

    componentDidUpdate(props, prevState) {
        if (prevState.selectedTemplate !== this.state.selectedTemplate && this.props.setup){
            if (!window?.activity?.whatsapp) {
                this.setState({parameters: [], mediaParameters: {}})
            }
        }
    }

    handleFilterChange = (value) => {
        let templates = this.props.templates
        if (getSession().profile.enterprise.abstraction_layer)
            templates = this.state.numberTemplates
        this.setState({
            filteredTemplates: (templates.filter((template) => {
                const body = template.components?.find(each =>
                    each.type == 'BODY')?.text?.toLowerCase().includes(value.toLowerCase())
                const name = template.name?.toLowerCase().includes(value.toLowerCase())
                if (value && (body || name))
                    return true
                else if (value === "")
                    return true
            }))
        })
    }

    handleStoredTemplate = (value) => {
        let templates = this.props.templates
        if (getSession().profile.enterprise.abstraction_layer)
            templates = this.state.numberTemplates
        
        const template = templates.find((t) => t.name === value)
        const templatePosition = templates.findIndex((t) => t.name === value)
        if (templatePosition > -1) {
            const [foundTemplate] = templates.splice(templatePosition, 1)
            templates.unshift(foundTemplate)
        }

        this.setState({ selectedTemplate: template })
    }

    canSendTemplates = () => {
        if (this.state.showParameters)
            return this.state.allParamsFilled ? this.state.allParamsFilled : ""

        let msg = []
        if (! this.props.selectionIds.length)
            msg.push(<Box>Selecione quais contatos receberão a mensagem.</Box>)
        if (! this.props.hideQueues && this.state.queue === null)
            msg.push(<Box>Selecione a Fila.</Box>)
        if (! this.props.hideNumbers && this.state.originNumber === null)
            msg.push(<Box>Selecione o Número de origem.</Box>)
        if (this.state.selectedTemplate === null)
            msg.push(<Box>Selecione o Template.</Box>)
        if (msg.length == 0)
            return ""
        return (msg)
    }

    renderMessage = () => {
        let parsedHeader, parsedBody, parsedFooter, attachments

        const header = this.state.selectedTemplate.components.find((component) => component.type === "HEADER")
        if (header) {
            let mediaUrl = this.state.mediaParameters["headerfile"] ?? this.state.mediaParameters["headerURL"] ?? header.example?.header_handle?.[0]
            if (mediaUrl instanceof File)
                mediaUrl = URL.createObjectURL(mediaUrl)
            switch (header.format) {
                case "IMAGE":
                    parsedHeader = (
                        <img src={mediaUrl} style={{ maxWidth: "100%", marginBottom: ".5rem" }}/>
                    )
                    break
                case "DOCUMENT":
                    parsedHeader = (
                        <a href={mediaUrl} target="_blank" rel="noopener noreferrer" style={{ marginBottom: ".5rem" }}>
                            Documento
                        </a>
                    )
                    break
                case "VIDEO":
                    parsedHeader = (
                        <video controls style={{ maxWidth: "100%", marginBottom: ".5rem" }}>
                            <source src={mediaUrl} />
                        </video>
                    )
                break
                case "TEXT":
                    parsedHeader = (
                        <div style={{ marginBottom: "1rem", fontWeight: "bold" }}>{header.text}</div>
                    )
                break
                default:
                break
            }
        }

        const body = this.state.selectedTemplate.components.find((component) => component.type === "BODY")
        if (body) {
            parsedBody = body["text"]
            const bodyParams = this.state.mediaParameters?.body
            if (bodyParams && typeof bodyParams === "object") {
                Object.entries(bodyParams).forEach(([key, value]) => {
                    const placeholder = `{{${parseInt(key, 10) + 1}}}`
                    parsedBody = parsedBody.replaceAll(placeholder, value)
                })
            }
        }

        const footer = this.state.selectedTemplate.components.find((component) => component.type === "FOOTER")
        if (footer)
            parsedFooter = (
                <div style={{ marginTop: "1rem", color: "gray" }}>{footer.text}</div>
            )

        return (
            <Box className="summary-message-template">
                {parsedHeader ?? null}
                {parsedBody &&
                    <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
                        {parsedBody}
                    </pre>
                }
                {Array.isArray(attachments) && attachments.length > 0 &&
                    <Box mt={2}>
                        {attachments.map((attachment, i) => (
                            <div key={i}>
                                Anexo:{" "}
                                <a href={attachment.acess_directory} target="_blank" rel="noopener noreferrer">
                                    {attachment.filename}
                                </a>
                            </div>
                        ))}
                    </Box>
                }
                {parsedFooter ?? null}
            </Box>
        )
    }

    templateApprovalTimedOut = (startedAt) => {
        return Date.now() - startedAt >= TEMPLATE_APPROVAL_TIMEOUT_MS
    }

    updateTemplateApprovalLoading = (startedAt) => {
        if (! this.templateApprovalTimedOut(startedAt) || this.state.templateLoadingClosable)
            return

        this.setState({
            templateLoadingMessage: TEMPLATE_APPROVAL_TIMEOUT_MESSAGE,
            templateLoadingClosable: true
        })
    }

    reloadPage = () => {
        window.location.reload()
    }

    getUncachedTemplates = async (startedAt) => {
        await api.get(`api/enterprises/${getSession().profile.enterprise.id}/templates/?update=True`)
        return new Promise((resolve, reject) => {
            const poll = async () => {
                try {
                    this.updateTemplateApprovalLoading(startedAt)
                    const response = await api.get(`api/enterprises/${getSession().profile.enterprise.id}/templates/`)
                    const stillCaching = Object.values(response.data).some(value => value === "caching...")
                    if (stillCaching)
                        setTimeout(poll, TEMPLATE_APPROVAL_POLL_INTERVAL_MS)
                    else {
                        const allTemplates = Object.values(response.data).map(entry => entry.waba_templates || []).flat()
                        resolve(allTemplates)
                    }
                } catch (err) {
                    reject(err)
                }
            }
            poll()
        })
    }

    checkTemplateStatus = async (template) => {
        const startedAt = Date.now()
        this.setState({
            templateLoadingMessage: TEMPLATE_APPROVAL_WAITING_MESSAGE,
            templateLoadingClosable: false
        })
        const poll = async () => {
            this.updateTemplateApprovalLoading(startedAt)

            let templates
            try {
                templates = await this.getUncachedTemplates(startedAt)
            } catch (err) {
                this.setState({ templateLoading: false })
                await useNotification(
                    "Atenção!",
                    "Não foi possível verificar a aprovação do template agora. Tente novamente em alguns instantes.",
                    "warning"
                )
                return
            }

            const newTemplate = templates.find((item) => item.id === template.id)
            if (! newTemplate) {
                this.setState({
                    templateLoading: false,
                    templateLoadingClosable: false
                })
                return
            }
            switch (newTemplate.status) {
                case "APPROVED":
                    this.onChangeOriginNumbers(this.state.originNumber)
                    await useNotification(
                        "Sucesso",
                        "Seu template foi aprovado e está pronto para uso.",
                        "success"
                    )
                    this.setState({
                        templateLoading: false,
                        templateLoadingClosable: false
                    })
                    return
                case "REJECTED":
                    await useNotification(
                        "Atenção!",
                        "Seu template não foi aprovado pelo WhatsApp, tente novamente.",
                        "danger"
                    )
                    this.setState({
                        templateLoading: false,
                        templateLoadingClosable: false
                    })
                    return
                default:
                    setTimeout(poll, TEMPLATE_APPROVAL_POLL_INTERVAL_MS)
            }
        }
        poll()
    }

    render = () => {
        return (
            <>
                <Loading loading={this.state.loading} />
                <Loading
                    loading={this.state.templateLoading}
                    message={this.state.templateLoadingMessage}
                    onClose={this.state.templateLoadingClosable ? this.reloadPage : null}
                />
                {this.state.newTemplateDialog &&
                    <Modal
                        open={this.state.newTemplateDialog}
                        handleClose={() => this.setState({ newTemplateDialog: false })}
                        template={{}}
                        readTemplate={false}
                        copyTemplate={false}
                        categories={{
                            "MARKETING"      : "Marketing",
                            "UTILITY"        : "Utilidades",
                            "AUTHENTICATION" : "Autenticação"
                        }}
                        getTemplates={() => this.setState({ 
                            templateLoading: true,
                            templateLoadingMessage: TEMPLATE_APPROVAL_WAITING_MESSAGE,
                            templateLoadingClosable: false,
                            newTemplateDialog: false 
                        })}
                        errorValidation={(res) => useValidationError(res.status, res.message)}
                        postProcess={(template) => this.checkTemplateStatus(template)}
                    />
                }
                {! this.state.newTemplateDialog &&
                    <Dialog keepMounted
                        open={this.props.open}
                        onClose={this.props.handleClose}
                        aria-labelledby="customized-dialog-title"
                        className={this.state.showParameters ? 'PreviewTemplateDialog' : null}
                        disablePortal
                        disableEnforceFocus
                        sx={{position: this.props.positionFixed ? 'fixed': 'absolute'}}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="customized-dialog-title" className={'group-flexbox'}>
                            <span>{this.props.title ? this.props.title : "Enviar notificação aos contatos selecionados"}</span>
                            <Box>
                                <Button onClick={() => window.open("https://instant.getoutline.com/s/canal-do-cliente/doc/como-realizar-disparos-de-mensagens-ativas-no-kwik-NakmzYWPZL", "_blank")}>FAQ</Button>
                                <Tooltip title="Fechar" >
                                    <Button className="action-button">
                                        <CloseIcon onClick={this.props.handleClose} />
                                    </Button>
                                </Tooltip>
                            </Box>
                        </DialogTitle>
                        <Divider />
                        <DialogContent ref={instance => { this.content = instance; }}>
                            {! this.state.showParameters &&
                                <>
                                    {! this.props.hideNumbers &&
                                        <>
                                            <Typography className="typography-title" variant="h6" gutterBottom>
                                                Defina o número de envio
                                            </Typography>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="demo-simple-select-label">Número</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Número"
                                                    onChange={(event) => this.onChangeOriginNumbers(event.target.value)}
                                                    value={this.state.originNumber}
                                                >
                                                    {this.props.originNumbers.map((number, index) => (
                                                        <MenuItem key={index} value={number}>{number}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                    }
                                    {! this.props.hideQueues &&
                                        <>
                                            <Typography className="typography-title" variant="h6" gutterBottom>
                                                Defina a fila de atendimento que receberá a resposta do contato
                                            </Typography>
                                            <FormControl fullWidth size="small">
                                                <InputLabel id="demo-simple-select-label">Fila</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Fila"
                                                    onChange={this.onChangeQueues}
                                                    value={this.state.queue}
                                                >
                                                    <MenuItem value="">Sem fila</MenuItem>
                                                    {this.state.queues.map((queue, index) => (
                                                        <MenuItem key={index} value={this.props.queues[queue]}>{queue}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                    }
                                    <Typography className="typography-title" variant="h6" gutterBottom>
                                        Defina a mensagem que deseja enviar
                                        {getSession().profile.enterprise.abstraction_layer && <Button onClick={() => this.setState({ newTemplateDialog: true })}>Criar template</Button>}
                                    </Typography>
                                    <Autocomplete size="small" fullWidth
                                        options={this.state.filteredTemplates.sort((a, b) => {
                                            const groupA = a.owner_id ? 0 : 1
                                            const groupB = b.owner_id ? 0 : 1
                                            return groupA - groupB
                                        })}
                                        groupBy={(option) => option.owner_id ? "Meus templates" : "Templates públicos"}
                                        getOptionLabel={(option) => option.name}
                                        value={this.state.selectedTemplate}
                                        onChange={(event, newValue) => this.setState({ 
                                            selectedTemplate: newValue, 
                                            parameters: [],
                                            mediaParameters: {}
                                        }, () => this.fillParameters())}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Template" variant="outlined" />
                                        )}
                                    />
                                    <Alert severity="info" className="template-alert-info">
                                        Devido à política WhatsApp Business, somente modelos de mensagem pré-aprovados podem ser enviados.
                                    </Alert>
                                    {this.state.selectedTemplate &&
                                        <>
                                            <Typography className="typography-title" variant="h6" gutterBottom>
                                                A seguir, a mensagem que seu cliente receberá
                                            </Typography>
                                            {this.state.mediaParameters?.headerURL && (
                                                <Box sx={{ mb: 2 }}>
                                                    <Button 
                                                        size="small" 
                                                        variant="outlined"
                                                        color="primary"
                                                        onClick={() => this.handleChangeImage()}
                                                    >
                                                        Alterar imagem
                                                    </Button>
                                                </Box>
                                            )}
                                            {this.state.selectedTemplate && this.renderMessage()}
                                        </>
                                    }
                                </>
                            }
                            {this.state.showParameters &&
                                <Box>
                                    <ParameterFiller
                                        mediaValues={this.state.selectedTemplate.components}
                                        parameters={this.state.parameters}
                                        submitParameters={this.state.mediaParameters}
                                        setReady={this.allParametersFilled}
                                    />
                                </Box>
                            }
                        </DialogContent>
                        <DialogActions style={{ padding: "10px 20px 10px 10px" }}>
                            {this.state.showParameters &&
                                <>
                                    <Button
                                        onClick={() => this.setState({
                                            selectedTemplate: null,
                                            showParameters: false,
                                            parameters: [],
                                            mediaParameters: {},
                                            allParamsFilled: true
                                        })}
                                        color="primary"
                                    >
                                        Voltar
                                    </Button>
                                    <Button 
                                        color="primary" 
                                        onClick={() => this.setState({ showParameters: false })}
                                        disabled={this.canSendTemplates()}
                                    >
                                        Salvar
                                    </Button>
                                </>
                            }
                            {! this.state.showParameters &&
                                <>
                                    <LoadingButton onClick={this.props.handleClose} color="primary" loading={this.state.loading}>
                                        Cancelar
                                    </LoadingButton>
                                    <Tooltip title={this.canSendTemplates()} placement="top" describeChild={true}>
                                        <span><LoadingButton
                                            onClick={() => {
                                                if (this.props.handleSubmit !== undefined) {
                                                    this.props.handleSubmit(
                                                        this.state.selectedTemplate,
                                                        this.state.parameters,
                                                        this.state.mediaParameters
                                                    )
                                                    return
                                                }
                                                this.submit()
                                            }}
                                            color="primary"
                                            disabled={this.canSendTemplates()}
                                            loading={this.state.loading}
                                        >
                                            {this.props?.setup ? 'Salvar' : 'Enviar'}
                                        </LoadingButton></span>
                                    </Tooltip>
                                </>
                            }
                        </DialogActions>
                    </Dialog>
                }
            </>
        )
    }

}

export default Templates;
